import { render } from "./export_indesign.vue?vue&type=template&id=716b6e64"
import script from "./export_indesign.vue?vue&type=script&lang=js"
export * from "./export_indesign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__